import { provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { ApiTranslationLoader } from './services/api-translation-loader';
import { routes } from './app.routes';
import { buildOriginBaseUrl } from './utils/url-helper';

export type SupportedLanguage = 'en-GB' | 'pt-BR' | 'es-AR';

export function resolveLanguageFromSearch(search: string): SupportedLanguage | null {
  const raw = new URLSearchParams(search).get('lang');
  if (!raw) {
    return null;
  }

  const normalized = raw.trim().toLowerCase();

  const possibleValuesBr = ['pt', 'pt-br'];
  const possibleValuesEn = ['en', 'en-gb', 'en-us'];
  const possibleValuesEs = ['es', 'es-ar', 'es-es'];

  if (possibleValuesEn.includes(normalized)) {
    return 'en-GB';
  }

  if (possibleValuesBr.includes(normalized)) {
    return 'pt-BR';
  }

  if (possibleValuesEs.includes(normalized)) {
    return 'es-AR';
  }

  return null;
}

function resolveInitialLanguage(): SupportedLanguage {
  const browserGlobal = globalThis as typeof globalThis & { location?: Location };
  const search = browserGlobal.location?.search ?? '';
  return resolveLanguageFromSearch(search) ?? 'pt-BR';
}

export const appConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideTranslateService({
      lang: resolveInitialLanguage(),
      fallbackLang: 'pt-BR',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new ApiTranslationLoader(http, buildOriginBaseUrl()),
        deps: [HttpClient],
      },
    }),
  ]
};
